import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "loadingBar" ]
      
  initialize() {
    this.hitCounter = 0
    this.switchTracker = true
  }

  connect() {
    console.log("infinite scroll")
  }

  async scroll(event) {
    const scrollableHeight = this.element.scrollHeight - this.element.clientHeight
    const scrollLevel = this.element.scrollTop / scrollableHeight

    if (scrollableHeight <= 0 || scrollLevel <= 0.8 || !this.switchTracker || this.providersExhausted) return

    this.switchTracker = false
    this.loadingBarTarget.classList.remove("d-none")
    const nextPage = this.hitCounter + 1
    const params = new URLSearchParams(window.location.search)
    params.set("counter", nextPage)

    try {
      const response = await fetch(`/providers/list_all?${params.toString()}`, {
        headers: { 'Accept': 'text/plain' },
        redirect: "error"
      })
      if (!response.ok) throw new Error(`Provider loading failed (${response.status})`)

      const data = await response.text()
      if (data.trim()) {
        const providersBody = this.element.querySelector(".portal-providers-body") || this.element
        providersBody.insertAdjacentHTML("beforeend", data)
      } else {
        this.providersExhausted = true
      }
      this.hitCounter = nextPage
    } catch (error) {
      console.error("Unable to load more providers:", error)
    } finally {
      this.loadingBarTarget.classList.add("d-none")
      this.switchTracker = true
    }
  }

  scrollCompanies(event) {
    const scrolLevel = this.element.scrollTop / (this.element.scrollHeight - this.element.clientHeight)

    if(scrolLevel > 0.8 && this.switchTracker) {
      this.switchTracker = false
      this.hitCounter += 1

      this.loadingBarTarget.classList.toggle("d-none")

      // Check if there's a companies-list controller with active sorting or filtering
      const companiesListController = this.application.getControllerForElementAndIdentifier(
        document.querySelector('[data-controller*="companies-list"]'),
        'companies-list'
      )

      if (companiesListController) {
        const sortState = companiesListController.getCurrentSortState()
        const hasFilters = (companiesListController.currentCountries && companiesListController.currentCountries.length > 0) ||
                          (companiesListController.currentRegions && companiesListController.currentRegions.length > 0) ||
                          (companiesListController.currentSectors && companiesListController.currentSectors.length > 0) ||
                          (companiesListController.searchQuery && companiesListController.searchQuery.length > 0)
        
        if (sortState.hasSorting || hasFilters) {
          // Use sorted/filtered endpoint with pagination
          companiesListController.loadMoreSortedCompanies(this.hitCounter)
            .then((data) => {
              this.loadingBarTarget.classList.toggle("d-none")
              if (data) {
                this.element.insertAdjacentHTML("beforeend", data)
              }
              this.switchTracker = true;
            })
            .catch((error) => {
              console.error('Error loading more sorted companies:', error)
              this.loadingBarTarget.classList.toggle("d-none")
              this.switchTracker = true;
            })
          return
        }
      }

      // Default behavior for unsorted companies
      let url = `/companies?counter=${this.hitCounter}`

      fetch(url, { headers: {'Accept': 'text/plain' }})
      .then(response => response.text())
      .then((data) => {
          this.loadingBarTarget.classList.toggle("d-none")
          this.element.insertAdjacentHTML("beforeend", data)
          this.switchTracker = true;
      })
    }
  }

  scrollGeoCompanies(event) {
    const scrolLevel = this.element.scrollTop / (this.element.scrollHeight - this.element.clientHeight)

    if(scrolLevel > 0.8 && this.switchTracker) {
      this.switchTracker = false
      this.hitCounter += 1

      this.loadingBarTarget.classList.toggle("d-none")

      let url = window.location.href + `&counter=${this.hitCounter}&geo_companies=true&code=${event.currentTarget.dataset.code}`
      console.log(url)
      fetch(url, { headers: {'Accept': 'text/plain' }})
      .then(response => response.text())
      .then((data) => {
          this.loadingBarTarget.classList.toggle("d-none")
          this.element.insertAdjacentHTML("beforeend", data)
          this.switchTracker = true
      })
    }
  }

  scrollSectorCompanies(event) {
    const scrolLevel = this.element.scrollTop / (this.element.scrollHeight - this.element.clientHeight)

    if(scrolLevel > 0.8 && this.switchTracker) {
      this.switchTracker = false
      this.hitCounter += 1

      this.loadingBarTarget.classList.toggle("d-none")

      let url = window.location.href + `&counter=${this.hitCounter}&sector_companies=true`
      fetch(url, { headers: {'Accept': 'text/plain' }})
      .then(response => response.text())
      .then((data) => {
          this.loadingBarTarget.classList.toggle("d-none")
          this.element.insertAdjacentHTML("beforeend", data)
          this.switchTracker = true;
      })
    }
  }

  addCompany(event) {
    const elementChecked = event.currentTarget.checked
    const counter = document.getElementById("cartCounter")
    let url = ''

    if(elementChecked) {
      url = `/companies/add_to_cart/${event.currentTarget.id}`
    } else {
      url = `/companies/remove_from_cart/${event.currentTarget.id}`
    }
    
    fetch(url, { headers: {'Accept': 'text/plain' }})
    .then(response => response.text())
    .then((data) => {
      if(counter.innerText == "") {
        counter.innerText = 1
      } else {
        if(elementChecked) {
          counter.innerText = parseInt(counter.innerText) + 1
        } else {
          counter.innerText = parseInt(counter.innerText) - 1
        }
      }
    })
  }
}
